/**
 * The answer key of a rush hour is a sequence of slides. Kept apart from the form component
 * so the eagerly loaded module file never pulls the author's lot into the player bundle.
 */
import { parseBoard, replay } from "./lot";
import { MOVE_PATTERN, type RushDefinition, type RushSolution } from "./types";

/** Nothing played yet: an empty key, which `validate_solution` refuses on save. */
export function emptySolution(_definition: RushDefinition): RushSolution {
  return { moves: [] };
}

/** Whether a stored value is a sequence of slides at all. */
export function isSlideLog(value: unknown): value is RushSolution {
  if (typeof value !== "object" || value === null || Array.isArray(value)) return false;
  const moves = (value as { moves?: unknown }).moves;
  return Array.isArray(moves) && moves.every((m) => typeof m === "string" && MOVE_PATTERN.test(m));
}

/** Reads whatever is stored, however wrong, as the slides this lot can play. */
export function movesOf(value: unknown, definition: RushDefinition): string[] {
  const parsed = parseBoard(definition.board);
  if (!isSlideLog(value) || !parsed) return [];
  return replay(parsed.lot, parsed.state, value.moves).moves;
}
